import u from "iconv-lite";
String.prototype.getMultiBytesSize = function() {
  let t = 0;
  for (let e = 0; e < this.length; e++) {
    const r = this.charCodeAt(e);
    r >= 0 && r < 129 || r === 63728 || r >= 65377 && r < 65440 || r >= 63729 && r < 63732 ? t += 1 : t += 2;
  }
  return t;
};
String.prototype.trimMaxLengthByMulti = function(t) {
  if (t < 0) return this.toString();
  if (t >= this.getUtf8BytesSize()) return this.toString();
  let e = this.toString();
  for (; e.getMultiBytesSize() > t; ) e = e.slice(0, -1);
  return e;
};
String.prototype.getUtf8BytesSize = function() {
  return new TextEncoder().encode(this.toString()).length;
};
String.prototype.trimMaxLengthByUtf8 = function(t) {
  let e = "";
  if (t >= this.getUtf8BytesSize())
    e = this.toString();
  else {
    let r = this.toString();
    for (; r.getUtf8BytesSize() > t; )
      r = r.slice(0, -1);
    e = r;
  }
  return e;
};
String.prototype.removeNotHalfNumber = function() {
  return this.replace(/[^0-9]/g, "");
};
String.prototype.removeNotHalfNumberDecimal = function() {
  return this.replace(/[^0-9\u002e]/g, "");
};
String.prototype.removeNotHalfChar = function() {
  return this.replace(/[^\x01-\x7E]/g, "");
};
String.prototype.removeUnUsemailAddressChar = function() {
  return this.replace(/[^a-zA-Z0-9@.+\-_]/g, "");
};
String.prototype.removeNotHalfCharAllowNewLine = function() {
  return this.replace(/[^\x01-\x7E\u000A\u000D]/g, "");
};
String.prototype.includeChar = function(t) {
  for (let e = 0; e < t.length; e++)
    if (this.includes(t.charAt(e)))
      return !0;
  return !1;
};
String.prototype.removeControlCode = function() {
  const t = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;
  return this.replace(t, "");
};
String.prototype.removeControlCodeAllowNewLine = function() {
  const t = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;
  return this.replace(t, "");
};
String.prototype.includeControlCode = function() {
  const t = /[\u0000-\u001F\u007F–\u00A0\u00AD]/g;
  return this.match(t) !== null;
};
String.prototype.includeControlCodeAllowNewLine = function() {
  const t = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F–\u00A0\u00AD]/g;
  return this.match(t) !== null;
};
String.prototype.includeFullChar = function() {
  const t = /[^\x01-\x7E\uFF61-\uFF9F]/g;
  return this.match(t) !== null;
};
String.prototype.includeHalfCharKANA = function() {
  const t = /[\uFF61-\uFF9F]/g;
  return this.match(t) !== null;
};
String.prototype.compareSort = function(t) {
  return this < t ? -1 : this > t ? 1 : 0;
};
String.prototype.makeCsvItemEx = function() {
  let t = !1;
  for (let e = 0; e < this.length; e++) {
    const r = this.charCodeAt(e);
    if (r == 10 || r == 13 || r == 44 || r == 34) {
      t = !0;
      break;
    }
  }
  return t == !1 ? this.toString() : '"' + this.replaceAll('"', '""') + '"';
};
String.prototype.removeNotSJIS = function() {
  const t = u.encode(this.normalize().toString(), "sjis");
  return u.decode(t, "sjis");
};
String.prototype.includeNotSJIS = function() {
  return this.removeNotSJIS() != u.encode(this.normalize().toString(), "utf-8").toString();
};
String.prototype.isValidMailAddress = function() {
  if (this.match("@") === null || this.length >= 256)
    return !1;
  let t = 0;
  for (t; t <= this.length && this.charCodeAt(t) != 64; )
    ++t;
  return !(t == 0 || (++t, this.length - t == 0) || new RegExp(/@.*\[[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+\]/).test(this.toString()));
};
String.prototype.isValidMailAddress2 = function() {
  const t = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return new RegExp(t).test(this.toString());
};
String.prototype.compareScvVersion = function(t) {
  const e = new RegExp(/^[0-9]+\.[0-9][0-9][0-9]\.[0-9]+.*/);
  if (!e.test(this.toString()) || !e.test(t))
    return !1;
  const r = this.split("."), o = t.split(".");
  let n = parseInt(r[0]), i = parseInt(o[0]);
  return n < i ? -1 : n > i ? 1 : (n = parseInt(r[1]), i = parseInt(o[1]), n < i ? -1 : n > i ? 1 : (n = parseInt(r[2]), i = parseInt(o[2]), n < i ? -1 : n > i ? 1 : 0));
};
String.prototype.createErrorsMessage = function(t) {
  const e = t.length;
  if (e == 0)
    return "";
  if (e == 1)
    return t[0];
  {
    let r = "・" + t[0];
    for (let o = 1; o < e; o++)
      r += "<br />・" + t[o];
    return r;
  }
};
String.prototype.escapeHtml = function() {
  const t = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  };
  return this.replace(/[<>&"'`]/g, function(e) {
    return t[e];
  });
};
String.prototype.designString = function(t) {
  const e = new RegExp("[^" + t + "]", "g");
  return this.replace(e, "");
};
String.prototype.designReplaceString = function(t) {
  const e = new RegExp("[" + t + "]", "g");
  return this.replace(e, "");
};
String.prototype.easyEncrypt = function() {
  const t = this, e = window.btoa(window.encodeURIComponent(t)), r = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split(""), o = r.length - 1, n = new Array(0);
  return e.split("").map((i) => {
    const s = r.indexOf(i) === o ? 0 : r.indexOf(i) + 1;
    n.push(r[s]);
  }), n.join("");
};
String.prototype.easyDecrypt = function() {
  const t = this, e = "cBu4UeHf+RFgzOXhlDJn72aoPTLrq5wvj3Yx8VCEi6GtIb0k9NKmydSp=W/MsZ1AQ".split(""), r = e.length - 1, o = new Array(0);
  return t.split("").map((n) => {
    const i = e.indexOf(n) === 0 ? r : e.indexOf(n) - 1;
    o.push(e[i]);
  }), decodeURIComponent(window.atob(o.join("")));
};
String.prototype.removeHalfSpaceChar = function() {
  return this.replace(/ /g, "");
};
String.prototype.format = function(...t) {
  return this.replace(/%s/g, () => t.shift() || "");
};
String.prototype.removeChars = function(t) {
  const e = new RegExp(`[${t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}]`, "g");
  return this.replace(e, "");
};
Date.prototype.CompareSystemTimeDateHourMinute = function(t) {
  return this.getFullYear() < t.getFullYear() ? -1 : this.getFullYear() > t.getFullYear() ? 1 : this.getMonth() < t.getMonth() ? -1 : this.getMonth() > t.getMonth() ? 1 : this.getDate() < t.getDate() ? -1 : this.getDate() > t.getDate() ? 1 : this.getHours() < t.getHours() ? -1 : this.getHours() > t.getHours() ? 1 : this.getMinutes() < t.getMinutes() ? -1 : this.getMinutes() > t.getMinutes() ? 1 : 0;
};
Date.prototype.CompareSystemTimeDate = function(t) {
  return this.getFullYear() < t.getFullYear() ? -1 : this.getFullYear() > t.getFullYear() ? 1 : this.getMonth() < t.getMonth() ? -1 : this.getMonth() > t.getMonth() ? 1 : this.getDate() < t.getDate() ? -1 : this.getDate() > t.getDate() ? 1 : 0;
};
Date.prototype.SystemtimeToStr3 = function() {
  const t = this.getDate(), e = this.getMonth() + 1, r = this.getFullYear(), o = this.getHours(), n = this.getMinutes(), i = this.getSeconds();
  return r.toString() + ("00" + e).slice(-2) + ("00" + t).slice(-2) + ("00" + o).slice(-2) + ("00" + n).slice(-2) + ("00" + i).slice(-2);
};
Date.prototype.SystemtimeToStr4 = function() {
  const t = this.getDate(), e = this.getMonth() + 1, r = this.getFullYear(), o = this.getHours(), n = this.getMinutes(), i = this.getSeconds(), s = this.getMilliseconds();
  return r.toString() + ("00" + e).slice(-2) + ("00" + t).slice(-2) + ("00" + o).slice(-2) + ("00" + n).slice(-2) + ("00" + i).slice(-2) + ("000" + s).slice(-3);
};
Date.prototype.SystemtimeToStr7 = function() {
  const t = this.getDate(), e = this.getMonth() + 1, r = this.getFullYear(), o = this.getHours(), n = this.getMinutes();
  return r.toString() + "/" + ("00" + e).slice(-2) + "/" + ("00" + t).slice(-2) + " " + ("00" + o).slice(-2) + ":" + ("00" + n).slice(-2);
};
Date.prototype.SystemtimeToStr7UTC = function() {
  const t = this.getUTCDate(), e = this.getUTCMonth() + 1, r = this.getUTCFullYear(), o = this.getUTCHours(), n = this.getUTCMinutes();
  return r.toString() + "/" + ("00" + e).slice(-2) + "/" + ("00" + t).slice(-2) + " " + ("00" + o).slice(-2) + ":" + ("00" + n).slice(-2);
};
Date.prototype.SystemtimeToDateStr = function() {
  const t = this.getDate(), e = this.getMonth() + 1, r = this.getFullYear();
  return this.getHours(), this.getMinutes(), `${r}/${("00" + e).slice(-2)}/${("00" + t).slice(-2)}`;
};
Date.prototype.AddMonth = function(t) {
  const e = new Date(this);
  if (this.setMonth(this.getMonth() + t), e.getDate() != this.getDate()) {
    this.setMonth(this.getMonth() - 1);
    const r = new Date(this.getFullYear(), this.getMonth() + 1, 0);
    this.setDate(r.getDate());
  }
};
Date.prototype.AddHour = function(t) {
  this.setHours(this.getHours() + t);
};
